import client from './main-client';

export const fetchLenderContactsApi = (params) => client().get('/lenders-contacts', { params });
export const addNewContactApi = (data) => client().post('/lenders-contacts', data);
export const editContactApi = (params) => client().patch(`/lenders-contacts/${params.id}`, params.values);
